import React, { useCallback } from "react";

import { useSlate } from "slate-react";

import { TextControl } from "../../type/Control";
import isTextTypeActive from "../../util/isTextTypeActive";
import toggleTextType from "../../util/toggleTextType";
import ToggleButton from "../ToggleButton";

import ActionTooltipWrapper from "./ActionTooltipWrapper";

interface TextTogglerProps {
  tooltipTranslationString: string;
  value: TextControl;
}

const TextToggler = ({ tooltipTranslationString, value }: TextTogglerProps) => {
  const editor = useSlate();
  const handleToggleBlock = useCallback(() => {
    toggleTextType(editor, value.value);
  }, [editor, value.value]);

  return (
    <ActionTooltipWrapper translationString={tooltipTranslationString}>
      <ToggleButton active={isTextTypeActive(editor, value.value)} onClick={handleToggleBlock}>
        {value.label}
      </ToggleButton>
    </ActionTooltipWrapper>
  );
};

export default TextToggler;
